import React from 'react';
import { useSelector } from 'react-redux';

import { getDataToUrlFromExternals } from '../../../actions/survey/surveyActions';
import {
  getUserDetail as getUserDetailSelector,
  isUserAdmin as isUserAdminSelector,
  isUserAuthenticated as isUserAuthenticatedSelector,
  selectManagementUnit,
} from '../../../selectors/users';
import SurveyHomeService from '../../../services/Qualtrics/Home';
import Dates from '../../../utils/dates';
import DateUtils from '../../../utils/DateUtils';
import ModalHomeSatisfactionSurvey from '../../Home/Survey';

const SurveyProvider = () => {
  const WAIT_DAYS = 30;
  const isUserAuthenticated = useSelector(isUserAuthenticatedSelector);
  const isUserAdmin = useSelector(isUserAdminSelector);
  const userDetail = useSelector(getUserDetailSelector);
  const managementUnit = useSelector(selectManagementUnit);
  const currentDate = new Date();

  const onAnalize = () => {
    const practitionerAMBA = SurveyHomeService.isInAMBA(managementUnit);
    const isDirectOrTeamProvider = ['P', 'E'].includes(userDetail?.tipoPrestador?.id);
    const closeSurveyAt = SurveyHomeService.getLastQualtricsSurveyClosed();
    const startDate = new Date(2024, 3, 1); // 01-04-2024
    const lastDate = new Date(2030, 11, 30);
    // Obtengo el dato de la última vez que se respondio la encuesta mas {WAIT_DAYS} dias.
    const nextDateShowSurvey = Dates.getWithAddDays(
      WAIT_DAYS,
      new Date(SurveyHomeService.getLastQualtricsSurveyResponse()),
    ).toDate();

    // Verifica si hoy esta entre los dias configurados anteriormente. Y verificar que se envie la encuesta una vez al mes.
    const shouldShow =
      currentDate >= startDate &&
      currentDate <= lastDate &&
      Dates.get().compareIsAfter(nextDateShowSurvey);
    // Comprueba si ya se mostró la encuesta hoy.
    const showSurveyToday = closeSurveyAt && closeSurveyAt === currentDate.toDateString();

    return (
      !showSurveyToday &&
      shouldShow &&
      isUserAuthenticated &&
      isUserAdmin &&
      isDirectOrTeamProvider &&
      practitionerAMBA
    );
  };

  const onClose = () => SurveyHomeService.setLastQualtricsSurveyClosed(currentDate.toDateString());

  const getIFrameUrl = async () => {
    const { fechaNacimiento: birthDate, sexo } = userDetail.tipoPersona;
    const {
      codPrestador: codprestador,
      nombrePrestador,
      apellidoPrestador,
    } = userDetail.modelEspecifico;
    const { id: tipoprestador } = userDetail.tipoPrestador;

    const { addresses, specialities } = await getDataToUrlFromExternals();

    const queryComponents = {
      origen: 'WEB_PRESTADORES',
      fecha: Dates.get().toFormat('DD-MM-YYYY'),
      codprestador,
      tipoprestador,
      edad: DateUtils.getAgeFromBirthDate(birthDate),
      sexo,
      nivelacceso: isUserAdmin ? 'admin' : 'usuario',
      // perfilusuario: (userProfile && userProfile[0]?.denominacion) ?? 'sinAsignar', // if is not admin search sector and role and denomination
      perfilusuario: 'sinAsignar', // beacause is admin. Its sinAsignar
      direcciones: addresses,
      especialidades: specialities,
      nombreprestador: `${nombrePrestador} ${apellidoPrestador}`,
    };

    const surveyUrlWithQueries = SurveyHomeService.createQueryFromObject(queryComponents);
    return `${SurveyHomeService.surveyURL}?${surveyUrlWithQueries}`;
  };

  return (
    <>
      {onAnalize() && <ModalHomeSatisfactionSurvey onClose={onClose} getIFrameUrl={getIFrameUrl} />}
    </>
  );
};

export default SurveyProvider;
